/* ====================================================================
   CART DRAWER — behaviour. 12-CART-DRAWER.md §4, §5, §7.

   Every render comes from the /cart.js response, never from local state:
   quantities can be clamped by inventory, and the drawer must show what the
   cart actually holds. The drawer also re-fetches on open, not only on add,
   so a cart emptied in another tab does not leave a stale list here.

   The ongkir copy and maths are kept identical to snippets/ss-ship-progress.liquid
   and snippets/ss-cart-drawer.liquid. tools/ongkir-check.mjs fails if they drift.
   ==================================================================== */
(function () {
  var root = document.getElementById('ss-cart-drawer');
  if (!root) return;

  var cfg = window.SS || {};
  var routes = cfg.routes || {
    cart: '/cart', cartAdd: '/cart/add.js', cartChange: '/cart/change.js',
    cartUpdate: '/cart/update.js', cartJson: '/cart.js'
  };

  var scrim = document.querySelector('.cd-scrim');
  var lines = root.querySelector('[data-cd-lines]');
  var countEl = root.querySelector('[data-cd-count]');
  var shipEl = root.querySelector('[data-cd-ship]');
  var shipTxt = root.querySelector('[data-cd-ship-txt]');
  var shipBar = root.querySelector('[data-cd-ship-bar]');
  var shipFill = root.querySelector('[data-cd-ship-fill]');
  var subEl = root.querySelector('[data-cd-sub]');
  var noteEl = root.querySelector('[data-cd-note]');
  var moreEl = root.querySelector('[data-cd-more]');
  var moreRow = root.querySelector('[data-cd-more-row]');
  var opener = null;

  // ---------- the ongkir rule ----------
  // Rupiah, not cents: /cart.js reports minor units, so every figure is /100 first.
  var STEP = 100000;   // every Rp 100.000 of goods…
  var OFF = 10000;     // …earns up to Rp 10.000 off ongkir
  // No CAP. The bar fills toward the NEXT step, never toward a ceiling, so there is
  // no "maximum reached" state to draw and no placeholder cap to get wrong.

  function rp(n) {
    return 'Rp ' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function ongkir(subMinor) {
    var sub = subMinor / 100;
    var earned = Math.floor(sub / STEP) * OFF;
    var rem = sub % STEP;
    return { sub: sub, earned: earned, toNext: STEP - rem, pct: Math.round((rem / STEP) * 100) };
  }
  // One line at 404px. "at checkout" is carried by the fine print, as in the design.
  function ongkirCopy(o) {
    if (o.sub === 0) return 'Every <strong>Rp 100.000</strong>: up to <strong>Rp 10.000</strong> off ongkir.';
    if (o.earned === 0) return 'Add <strong>' + rp(o.toNext) + '</strong> for up to Rp 10.000 off ongkir.';
    return 'Up to <strong>' + rp(o.earned) + '</strong> off ongkir — add <strong>' + rp(o.toNext) + '</strong> for more.';
  }
  // Both sentences, as in the Liquid: CSS picks the one the viewport wants.
  function fineCopy(o) {
    return o.earned > 0
      ? '<span class="cd-fine-long">Tax included. Ongkir is calculated at checkout — your <strong>up to ' + rp(o.earned) + '</strong> ongkir discount is applied there automatically.</span>' +
        '<span class="cd-fine-short">Ongkir at checkout — <strong>up to ' + rp(o.earned) + ' off</strong> applied there</span>'
      : '<span class="cd-fine-long">Tax included. Ongkir is calculated at checkout from your address.</span>' +
        '<span class="cd-fine-short">Tax included · ongkir calculated at checkout</span>';
  }

  // ---------- open / close ----------
  function focusables() {
    return [].slice.call(root.querySelectorAll('a[href], button:not([disabled]), textarea, summary, [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return el.offsetParent !== null; });
  }
  function open() {
    if (document.body.classList.contains('cd-open')) return;
    opener = document.activeElement;
    if (scrim) scrim.hidden = false;
    document.body.classList.add('cd-open');
    document.body.style.overflow = 'hidden';
    root.setAttribute('aria-hidden', 'false');
    refresh();
    // after the transition, or focus lands on an element still sliding in
    setTimeout(function () { var x = root.querySelector('.cd-x'); if (x) x.focus(); }, 380);
  }
  function close() {
    if (!document.body.classList.contains('cd-open')) return;
    document.body.classList.remove('cd-open');
    document.body.style.overflow = '';
    root.setAttribute('aria-hidden', 'true');
    root.style.transform = '';
    // Restore focus on the NEXT task, not inside the click handler: a mouse click on the scrim
    // moves focus to <body> AFTER the handler returns, so focusing here was immediately undone
    // and the keyboard user was dropped at the top of the page.
    var back = opener;
    opener = null;
    if (back && back.focus) setTimeout(function () { back.focus(); }, 0);
  }
  window.ssCartDrawer = { open: open, close: close, refresh: refresh };

  // A drag ends with a click. The grabber is also a close control, so without this a 40px drag
  // — the "short drag springs back" case — closed the sheet anyway on the click that followed.
  var swallowClick = false;
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cd-close]')) return;
    e.preventDefault();
    if (swallowClick) { swallowClick = false; return; }
    close();
  });
  document.addEventListener('keydown', function (e) {
    if (!document.body.classList.contains('cd-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    // The trap re-queries on every keypress, so it stays correct as lines are
    // added and removed underneath it.
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!root.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  });

  // ---------- phone: swipe the sheet down ----------
  var grab = root.querySelector('.cd-grab');
  if (grab && window.PointerEvent) {
    var y0 = null, moved = false;
    grab.addEventListener('pointerdown', function (e) { y0 = e.clientY; moved = false; grab.setPointerCapture(e.pointerId); });
    grab.addEventListener('pointermove', function (e) {
      if (y0 === null) return;
      var dy = Math.max(0, e.clientY - y0);
      if (dy > 4) moved = true;   // past this it is a drag, not a tap
      root.style.transition = 'none';
      root.style.transform = 'translateY(' + dy + 'px)';
    });
    grab.addEventListener('pointerup', function (e) {
      if (y0 === null) return;
      var dy = e.clientY - y0;
      y0 = null;
      root.style.transition = '';
      root.style.transform = '';
      // A tap closes (12 §4). A drag decides on distance, and the click it generates must not
      // also reach the close handler — hence swallowClick.
      swallowClick = moved;
      if (moved && dy > 90) close();
    });
  }

  // ---------- render ----------
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function lineHtml(it) {
    var size = it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title) + ' · ' : '';
    return '<div class="cd-line" data-busyrow data-cd-line="' + esc(it.key) + '">' +
      '<div class="cd-thumb">' + (it.image ? '<img src="' + esc(it.image) + '" alt="" loading="lazy">' : '') + '</div>' +
      '<div class="cd-info"><div class="cd-top">' +
        '<p class="cd-name"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        '<span class="cd-size">' + size + rp(it.final_price / 100) + ' each</span></p>' +
        '<span class="cd-price">' + rp(it.final_line_price / 100) + '</span>' +
      '</div><div class="cd-ctrl">' +
        '<span class="cd-qty">' +
          '<button type="button" data-cd-qty="-1" aria-label="Decrease quantity"' + (it.quantity <= 1 ? ' disabled' : '') + '>&minus;</button>' +
          '<span class="n" data-cd-n>' + it.quantity + '</span>' +
          '<button type="button" data-cd-qty="1" aria-label="Increase quantity">+</button>' +
        '</span>' +
        '<button class="cd-rm" type="button" data-cd-remove>Remove</button>' +
      '</div></div></div>';
  }

  var upsellPool = (function () {
    var tag = document.querySelector('[data-cd-upsell]');
    if (!tag) return [];
    try { return JSON.parse(tag.textContent) || []; } catch (e) { return []; }
  })();

  function renderUpsell(cart) {
    if (!moreEl || !moreRow) return;
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = true; });
    var picks = upsellPool.filter(function (p) { return !inCart[p.id]; }).slice(0, 3);
    if (!picks.length) { moreEl.hidden = true; moreRow.innerHTML = ''; return; }
    moreEl.hidden = false;
    moreRow.innerHTML = picks.map(function (p) {
      return '<button class="cd-chip" type="button" data-cd-add="' + esc(p.vid) + '">' +
        (p.img ? '<img src="' + esc(p.img) + '" alt="">' : '') +
        '<span class="t">' + esc(p.title) + ' ' + esc(p.size) + '</span>' +
        '<span class="p">' + esc(p.price) + '</span></button>';
    }).join('');
  }

  function render(cart) {
    root.classList.toggle('is-empty', cart.item_count === 0);
    if (countEl) countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    if (lines) lines.innerHTML = cart.items.map(lineHtml).join('');
    if (subEl) subEl.textContent = rp(cart.items_subtotal_price / 100);
    [].forEach.call(root.querySelectorAll('[data-cd-total]'), function (el) {
      el.textContent = rp(cart.total_price / 100);
    });
    if (shipEl) {
      var o = ongkir(cart.items_subtotal_price);
      if (shipTxt) shipTxt.innerHTML = ongkirCopy(o);
      var fine = root.querySelector('[data-cd-fine]');
      if (fine) fine.innerHTML = fineCopy(o);
      if (shipFill) shipFill.style.width = o.pct + '%';
      if (shipBar) shipBar.setAttribute('aria-valuenow', o.pct);
    }
    renderUpsell(cart);
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
  }

  // ---------- writes ----------
  // r.ok is not optional. Shopify answers 422 with { description } when a line cannot be added
  // or a quantity cannot be met; a handler that skips the check renders that error object as if
  // it were a cart — the list empties, the totals read "RpNaN". Throw, and let the caller's
  // .catch fall back to a fresh /cart.js so the drawer shows what the cart really holds.
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Cart error');
        return j;
      });
    });
  }
  function getCart() {
    return fetch(routes.cartJson, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function refresh() { return getCart().then(render).catch(function () {}); }

  function announce(cart) {
    document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    window.dispatchEvent(new CustomEvent('cartchange', { detail: cart }));
  }

  // CLAUDE.md rule 16 / docs/11: the shopper cannot see a fetch, so the control disables
  // itself, says what is happening, dims its row, and restores on BOTH paths. window.ssBusy
  // (ss-v2.js) is the shared helper — do not hand-roll this per surface. It returns null when
  // the control is ALREADY busy, which is how a second press stops being a second write.
  //
  // The +/- buttons pass no label: ssBusy swaps innerHTML for "spinner + label", and a 32px
  // circle has nowhere to put words. Disabled + aria-busy + the dimmed row is the feedback
  // there; the row dim is what makes it obvious WHICH line is working in a long list.
  function busy(el, label) {
    if (window.ssBusy) return window.ssBusy(el, label);
    if (!el || el.disabled) return null;
    el.disabled = true;
    return function () { el.disabled = false; };
  }

  function write(el, label, body) {
    var release = busy(el, label);
    if (!release) return Promise.resolve();   // already in flight
    return post(routes.cartChange, body)
      .then(function (cart) { render(cart); announce(cart); return cart; })
      .catch(function () { return refresh(); })
      .then(function (r) { release(); return r; });
  }

  root.addEventListener('click', function (e) {
    var qty = e.target.closest('[data-cd-qty]');
    if (qty) {
      var line = qty.closest('.cd-line');
      var n = parseInt(line.querySelector('[data-cd-n]').textContent, 10) || 1;
      var next = n + parseInt(qty.getAttribute('data-cd-qty'), 10);
      if (next < 1) return;   // "−" at 1 is disabled, not a delete
      write(qty, null, { id: line.getAttribute('data-cd-line'), quantity: next });
      return;
    }
    var rm = e.target.closest('[data-cd-remove]');
    if (rm) {
      var l = rm.closest('.cd-line');
      write(rm, rm.dataset.ssBusy || 'Removing…', { id: l.getAttribute('data-cd-line'), quantity: 0 });
      return;
    }
    var add = e.target.closest('[data-cd-add]');
    if (add) {
      // no label: the chip is an image card, and replacing its innerHTML would erase it
      var rel = busy(add, null);
      if (!rel) return;
      post(routes.cartAdd, { items: [{ id: add.getAttribute('data-cd-add'), quantity: 1 }] })
        .then(getCart)
        .then(function (cart) { render(cart); announce(cart); })
        .catch(function () { return refresh(); })
        .then(function () { rel(); });
    }
  });

  // note: debounced, silent
  if (noteEl) {
    var t = null;
    noteEl.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () { post(routes.cartUpdate, { note: noteEl.value }); }, 600);
    });
  }

  // Another surface wrote the cart (ss-v2.js add, the cart page): re-render.
  ['theme:cart:change', 'cart:updated'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (e.detail && e.detail.cart) render(e.detail.cart);
    });
  });
})();
